<template>
  <div>
    <!-- <div @click="goBack">返回</div> -->
    <div :id="id" class="provinceCharts" style="height: 600px; width: 100%"></div>
  </div>
</template>

<script>
export default {
  name: "province",
  props: {
    provinceInfo: {},
    heatData: [],
    type: null,
    code: null,
  },
  data() {
    return {
      id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
      echartObj: null,
      arry: [],
    };
  },
  mounted() {
    this.initDate();
    this.resizeListener();
  },
  methods: {
    initDate() {
      // debugger
      this.provinceJSON = require("../../utils/省份数据/json(省份)/" +
        this.provinceInfo.name);
      this.echartObj = this.$echarts.init(document.getElementById(this.id));
      this.$echarts.registerMap(this.provinceInfo.name, this.provinceJSON);
      this.initEchartsOption();
      this.echartObj.on("click", (params) => {
        this.$emit("backChina", "111111");
      });
      console.log("zhixingle");
      // debugger;
    },
    initEchartsOption() {
      var timeArry = [];
      timeArry = this.heatData;
      console.log(timeArry, "timeArrytimeArry");
      var geoNameb = this.provinceInfo.name;
      // debugger
      var option = {
        title: {
          text: "",
          top: "8%",
          left: "8%",
          textStyle: {
            fontSize: 14,
            fontWeight: 300,
            color: "#000",
          },
        },
        visualMap: {
          min: 0,
          max: 100,
          calculable: true,
          right: 80,
          bottom: 40,
          itemWidth:10,
          // borderWidth:10,
          // text: ["高", "低"], // 取值范围的文字
          inRange: {
            color: ["#85FF03", "#FFBB00", "#FF3131",], // 取值范围的颜色
          },
          // show: true, // 图注
        },
        geo: {
          map: geoNameb,
          aspectScale:1,
          zoom:0.75,
          // top:100,
          // layoutCenter: ['50%', '45%'],
          // layoutSize:650,
          // label: {
          //   normal: {
          //     show: true,
          //     fontSize: 10,
          //     color: "#000",
          //   },
          // },
          // itemStyle: {
          //   normal: {
          //     borderColor: "rgba(0, 0, 0, 0.2)",
          //   },
          //   emphasis: {
          //     areaColor: "skyblue", // 鼠标选择区域颜色
          //     shadowOffsetX: 0,
          //     shadowOffsetY: 0,
          //     shadowBlur: 20,
          //     borderWidth: 0,
          //     shadowColor: "rgba(0, 0, 0, 0.5)",
          //   },
          // },
          label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#2ab8ff",
                },
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#2ab8ff",
                borderWidth: 1.5,
                areaColor: "#081A8C",
              },
              emphasis: {
                areaColor: "#2AB8FF",
                borderWidth: 0,
                color: "green",
              },
            },
        },
        series: [
          {
            name: "热力图",
            type: "scatter",
            data: timeArry,
            coordinateSystem: "geo",
          },
          {
            name: "省份数据",
            type: "map",
            map: geoNameb,
            geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
            data: [],
            // label: {
            //   normal: {
            //     show: true,
            //     textStyle: {
            //       color: "#2ab8ff",
            //     },
            //   },
            // },
            // itemStyle: {
            //   normal: {
            //     borderColor: "#2ab8ff",
            //     borderWidth: 1.5,
            //     areaColor: "#081A8C",
            //   },
            //   emphasis: {
            //     areaColor: "#2AB8FF",
            //     borderWidth: 0,
            //     color: "green",
            //   },
            // },
          },
        ],
        provinceJSON: {},
      };
      this.echartObj.setOption(option);
    },
    resizeListener() {
      window.addEventListener("resize", () => {
        if (this.echartObj && this.echartObj.resize) {
          this.echartObj.resize();
        }
      });
    },
    goBack() {
      this.$emit("backChina", "111111");
    },
  },
};
</script>
<style lang="scss">
.provinceCharts {
  height: 480px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Map/province.vue